/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = pattern || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    } else if (typeof time === "string") {
      time = time
        .replace(new RegExp(/-/gm), "/")
        .replace("T", " ")
        .replace(new RegExp(/\.[\d]{3}/gm), "");
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields();
  }
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
  let search = params;
  search.params =
    typeof search.params === "object" &&
    search.params !== null &&
    !Array.isArray(search.params)
      ? search.params
      : {};
  dateRange = Array.isArray(dateRange) ? dateRange : [];
  if (typeof propName === "undefined") {
    search.params["beginTime"] = dateRange[0];
    search.params["endTime"] = dateRange[1];
  } else {
    search.params["begin" + propName] = dateRange[0];
    search.params["end" + propName] = dateRange[1];
  }
  return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
  var actions = [];
  Object.keys(datas).some((key) => {
    if (datas[key].value == "" + value) {
      actions.push(datas[key].label);
      return true;
    }
  });
  return actions.join("");
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
  if (value === undefined) {
    return "";
  }
  var actions = [];
  var currentSeparator = undefined === separator ? "," : separator;
  var temp = value.split(currentSeparator);
  Object.keys(value.split(currentSeparator)).some((val) => {
    Object.keys(datas).some((key) => {
      if (datas[key].value == "" + temp[val]) {
        actions.push(datas[key].label + currentSeparator);
      }
    });
  });
  return actions.join("").substring(0, actions.join("").length - 1);
}

// 字符串格式化(%s )
export function sprintf(str) {
  var args = arguments,
    flag = true,
    i = 1;
  str = str.replace(/%s/g, function () {
    var arg = args[i++];
    if (typeof arg === "undefined") {
      flag = false;
      return "";
    }
    return arg;
  });
  return flag ? str : "";
}

// 转换字符串，undefined,null等转化为""
export function parseStrEmpty(str) {
  if (!str || str == "undefined" || str == "null") {
    return "";
  }
  return str;
}

// 数据合并
export function mergeRecursive(source, target) {
  for (var p in target) {
    try {
      if (target[p].constructor == Object) {
        source[p] = mergeRecursive(source[p], target[p]);
      } else {
        source[p] = target[p];
      }
    } catch (e) {
      source[p] = target[p];
    }
  }
  return source;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  let config = {
    id: id || "id",
    parentId: parentId || "parentId",
    childrenList: children || "children",
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
  let result = "";
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && typeof value !== "undefined") {
      if (typeof value === "object") {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && typeof value[key] !== "undefined") {
            let params = propName + "[" + key + "]";
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result;
}

//数组去重
export function uniqueArr(arr) {
  if (!Array.isArray(arr)) {
    // console.log('type error!')
    return;
  }
  var array = [];
  for (var i = 0; i < arr.length; i++) {
    if (array.indexOf(arr[i]) === -1) {
      array.push(arr[i]);
    }
  }
  return array;
}

// 验证是否为blob格式
export async function blobValidate(data) {
  try {
    const text = await data.text();
    JSON.parse(text);
    return false;
  } catch (error) {
    return true;
  }
}

export function getBaseUrl() {
  return "https://boserai.com/boserai/"
  //return "https://boserai.umeweb.cn/boserai/";
  // return "/api/";
  //return "http://192.168.1.142:9999/";
}

export function getSocketUrl() {
  return "wss://boserai.com/boserai/ws";
//return "wss://boserai.umeweb.cn/boserai/ws";
//return "ws://192.168.1.142:9999/ws";
}

export function getToken() {
  return localStorage.getItem("x-token");
}

export function copyToClip(content, message) {
  return new Promise((resolve, reject) => {
    // var aux = document.createElement("input");
    // aux.setAttribute("value", content);
    // document.body.appendChild(aux);
    // aux.select();
    // document.execCommand("copy");
    // document.body.removeChild(aux);

    // 创建一个临时元素
    var tempElement = document.createElement("textarea");
    // 设置样式
    tempElement.style.position = "absolute";
    tempElement.style.left = "-9999px";
    tempElement.style.top = "0";
    tempElement.style.whiteSpace = "pre-wrap";

    // 设置文本
    tempElement.textContent = content;

    // 添加到文档中
    document.body.appendChild(tempElement);

    // 选择文本
    tempElement.select();
    tempElement.setSelectionRange(0, 99999); // 兼容性解决方法

    // 复制文本
    document.execCommand("copy");

    // 删除临时元素
    document.body.removeChild(tempElement);
    resolve(true);
  });

  if (message == null) {
    // alert("复制成功");
  } else {
    // alert(message);
  }
}

// export function copyToClip(content, message) {
//   return new Promise( ( resolve, reject )=>{
//     var aux = document.createElement("input");
//     aux.setAttribute("value", content);
//     document.body.appendChild(aux);
//     aux.select();
//     document.execCommand("copy");
//     document.body.removeChild(aux);
//     resolve( true )
//   })

//   if (message == null) {
//       // alert("复制成功");

//   } else{
//       // alert(message);
//   }
// }

export function handleDownloadQrIMg(qrBase64) {
  // 这里是获取到的图片base64编码,这里只是个例子哈，要自行编码图片替换这里才能测试看到效果
  const imgUrl = `data:image/png;base64,${qrBase64}`;
  // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
  if (window.navigator.msSaveOrOpenBlob) {
    const bstr = atob(imgUrl.split(",")[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const blob = new Blob([u8arr]);
    window.navigator.msSaveOrOpenBlob(blob, "chart-download" + "." + "png");
  } else {
    // 这里就按照chrome等新版浏览器来处理
    const a = document.createElement("a");
    a.href = imgUrl;
    a.setAttribute("download", "chart-download");
    a.click();
  }
}

export function getUUID() {
  var uuid = "";
  if (window.localStorage && window.localStorage.getItem("in_device_id")) {
    uuid = window.localStorage.getItem("in_device_id");
  } else {
    uuid = UUIDGeneratorBrowser();
    // window.localStorage.clear();
    window.localStorage.setItem("in_device_id", uuid);
  }
  // console.info(uuid)
  return uuid;
}
function UUIDGeneratorBrowser() {
  var len = 30; //32长度
  var radix = 16; //16进制
  var chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  var uuid = [],
    i;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    var r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join("").toUpperCase();
}

export function timeStampToHumanReadable(timestamp) {
  // 创建一个新的 Date 对象，传入时间戳作为参数
  var date = new Date(timestamp);

  // 使用 Date 对象的方法获取年、月、日、小时、分钟和秒
  var year = date.getFullYear();
  var month = date.getMonth() + 1; // 月份从 0 开始，所以需要加 1
  var day = date.getDate();
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();

  // 格式化日期和时间为字符串
  var formattedDateTime =
    year +
    "-" +
    addLeadingZero(month) +
    "-" +
    addLeadingZero(day) +
    " " +
    addLeadingZero(hours) +
    ":" +
    addLeadingZero(minutes) +
    ":" +
    addLeadingZero(seconds);

  return formattedDateTime;
}
// 辅助函数，用于给单个数字添加前导零
function addLeadingZero(number) {
  if (number < 10) {
    return "0" + number;
  }
  return number;
}
